import React from 'react'
import { gql } from '@apollo/client'
import { NewsBannerFragment } from './__generated__/banner'
import { FeatureNewsCarousel } from '../../../components/FeatureNewsCarousel/FeatureNewsCarousel'
import { nonNull } from '../../../utils/nonNull'

export type BannerProps = {
  data: NewsBannerFragment[]
  imageFallbackUrl?: string
}

const NewsBanner: React.VFC<BannerProps> = ({ data, imageFallbackUrl, ...props }) => {
  return (
    <FeatureNewsCarousel {...props}>
      {nonNull(data).map((item, index) => (
        <FeatureNewsCarousel flickitySection key={index}>
          {/** @ts-ignore */}
          <FeatureNewsCarousel image src={item.newsDetailBanner?.[0]?.bannerImage?.[0]?.url??imageFallbackUrl} layout="fill" objectFit="cover" objectPosition="center" />
          <FeatureNewsCarousel contentSection>
            <FeatureNewsCarousel date>{new Date(item.postDate).toLocaleString('en-AU', { year: 'numeric', month: 'short', day: 'numeric' })}</FeatureNewsCarousel>
            <FeatureNewsCarousel title>{item.title}</FeatureNewsCarousel>
            <FeatureNewsCarousel description>{item.newsArticleDescription}</FeatureNewsCarousel>
            <FeatureNewsCarousel href={item.uri ? `/${item.uri}` : '#'} cta primary buttonColor="black">
              Find out more
            </FeatureNewsCarousel>
          </FeatureNewsCarousel>
        </FeatureNewsCarousel>
      ))}
    </FeatureNewsCarousel>
  )
}

export const Banner = React.memo(NewsBanner)

export const NEWS_BANNER_FRAGMENT = gql`
  fragment NewsBannerFragment on news_newsEntryType_Entry {
    postDate
    title
    newsArticleDescription
    uri
    newsDetailBanner {
      ... on newsDetailBanner_BlockType {
        id
        bannerImage {
          url
        }
      }
    }
    newsCategory {
      title
    }
  }
`